// test2406
(2406 && 0);
